<div class="input-group plus-minus-input d-inline-flex">
  <div class="btn input-group-button input-group-prepend cursor-pointer" (click)="decrease()">
    <i class="fa fa-minus" aria-hidden="true"></i>
  </div>
  <div class="input-group-field text-center">
    <span class="field-value">{{ quantity }}</span>
  </div>
  <div class="btn input-group-button input-group-append cursor-pointer" (click)="increase()">
    <i class="fa fa-plus" aria-hidden="true"></i>
  </div>
</div>
